import { IPromise } from 'angular';
import { IStorageProvider } from '../../app-common/services/storage-provider-contract';

export const AnalysisProjectServiceName = 'gpAnalysisProjectService';
export const AnalysisProjectProcessingServiceName = 'gpAnalysisProjectProcessingService';

export type AnalysisTaskStatus = 'pending' | 'running' | 'complete' | 'error';

export type AnalysisProjectStatus = 'uploaded' | 'importing' | 'imported' | 'error';

export interface AnalysisProject {
    id: string;
    fileName: string;
    fileType: string;
    fileSizeBytes: number;
    createdUtc: string;
    lastModifiedUtc: string;
    projectContext: string;
    status: AnalysisProjectStatus;
    errorMessage: string | null;
    tasks: AnalysisProjectBackgroundTask[];
    summary: ProjectSummary | null;
    reports: Report[];
}

export interface AnalysisProjectBackgroundTask {
    id: string;
    analysisProjectId: string;
    name: string;
    status: AnalysisTaskStatus;
    progressPercent: number;
    progressMessage: string | null;
    startedUtc: string | null;
    completedUtc: string | null;
}

export interface ProjectSummary {
    projectName: string;
    activityCount: number;
    resourceCount: number;
    startDate: string;
    endDate: string;
    totalDurationDays: number;
    criticalPathLength: number;
    milestoneCount: number;
}

export interface Report {
    id: string;
    title: string;
    sections: ReportSection[];
    isComplete: boolean;
    generatedUtc: string | null;
}

export interface ReportSection {
    heading: string;
    bodyHtml: string;
}

export interface IAnalysisProjectService {
    getProjects(): IPromise<AnalysisProject[]>;
    getProject(id: string): IPromise<AnalysisProject>;
    createProject(file: File): IPromise<AnalysisProject>;
    deleteProject(id: string): IPromise<void>;
    /**
     * Re-run the convert + analyze pipeline for an already-uploaded project.
     * Rejects with a plain user-facing string when the credit gate refuses (402).
     */
    retryConversion(id: string): IPromise<void>;
}

export interface IAnalysisProjectProcessingService {
    /** Initialise in-memory state from an already-imported project so Task 2 can run. */
    initFromImport(projectId: string, importedProjectData: any, storageProvider: IStorageProvider): void;
    /** Restore previously saved reports into the processing state (e.g. after page reload). */
    restoreSavedReports(projectId: string, reports: Report[]): void;
    getTaskStatus(projectId: string): AnalysisProjectBackgroundTask[];
    getProjectSummary(projectId: string): ProjectSummary | null;
    getReport(projectId: string, reportId: string): Report | null;
}
